import { render, staticRenderFns } from "./ModalSeleccionarAlcance.vue?vue&type=template&id=1f115702&scoped=true"
import script from "./ModalSeleccionarAlcance.vue?vue&type=script&lang=js"
export * from "./ModalSeleccionarAlcance.vue?vue&type=script&lang=js"
import style0 from "./ModalSeleccionarAlcance.vue?vue&type=style&index=0&id=1f115702&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f115702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f115702')) {
      api.createRecord('1f115702', component.options)
    } else {
      api.reload('1f115702', component.options)
    }
    module.hot.accept("./ModalSeleccionarAlcance.vue?vue&type=template&id=1f115702&scoped=true", function () {
      api.rerender('1f115702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otros-documentos/ModalSeleccionarAlcance.vue"
export default component.exports